import { useState, useContext } from 'react';

export const useToggleExpand = (): [boolean, () => void] => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggle = () => setIsExpanded(!isExpanded);

  return [isExpanded, toggle];
};

export const useGetLinks = context => {
  const value = useContext(context);

  return (key: string) => (value ? value[key] : []);
};
